import { LegalForm } from '../api';

export const LEGAL_FORM_LABELS: Record<LegalForm, string> = {
  [LegalForm.GmbhCoKg]: 'GmbH & Co. KG',
  [LegalForm.Gmbh]: 'GmbH',
  [LegalForm.Kg]: 'KG',
  [LegalForm.Ag]: 'AG',
  [LegalForm.Gbr]: 'GbR',
  [LegalForm.SoleProprietorship]: 'Einzelfirma',
  [LegalForm.RegisteredAssociation]: 'e.V.',
  [LegalForm.Foundation]: 'Stiftung',
  [LegalForm.Other]: 'sonstiges',
  [LegalForm.RegisteredMerchant]: 'e.K.',
  [LegalForm.Freelancer]: 'Freiberufler',
  [LegalForm.Ug]: 'UG',
  [LegalForm.Mbb]: 'mbB',
  [LegalForm.Ohg]: 'OHG',
  [LegalForm.Eg]: 'eG',
  [LegalForm.Se]: 'SE',
  [LegalForm.Municipality]: 'Gemeinde',
  [LegalForm.Aor]: 'AöR',
  [LegalForm.Egbr]: 'eGbR',
  [LegalForm.Ggmbh]: 'gGmbH',
};
